"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// 选择品牌车系车型综合弹窗 已包含弹窗显示屏蔽页面滚动功能
var react_1 = __importStar(require("react"));
var BrandPop_1 = require("../BrandPop");
var LinePop_1 = require("../LinePop");
var ProductPop_1 = require("../ProductPop");
var WithErrorHandler_1 = require("../WithErrorHandler");
var smartScroll_1 = __importDefault(require("../../utils/smartScroll"));
var smartScrollObj = {};
var SelectBLP = function (props) {
    var _a = props.selectedClose, selectedClose = _a === void 0 ? true : _a;
    var _b = __read(react_1.useState(false), 2), brandShow = _b[0], setBrandShow = _b[1];
    var _c = __read(react_1.useState(false), 2), lineShow = _c[0], setLineShow = _c[1];
    var _d = __read(react_1.useState(false), 2), productShow = _d[0], setProductShow = _d[1];
    var _e = __read(react_1.useState({
        brandId: -1,
    }), 2), selectedBrand = _e[0], setSelectedBrand = _e[1];
    var _f = __read(react_1.useState({ lineId: -1 }), 2), selectedLine = _f[0], setSelectedLine = _f[1];
    var _g = __read(react_1.useState({ productId: -1 }), 2), selectedProduct = _g[0], setSelectedProduct = _g[1];
    react_1.useEffect(function () {
        smartScrollObj.brandPop = new smartScroll_1.default('#brandsPop', [
            'brandList',
            'brandNav',
        ]);
        smartScrollObj.linePop = new smartScroll_1.default('#linesPop', 'linesPop_list');
        smartScrollObj.productPop = new smartScroll_1.default('#productsPop', 'productsPop_list');
    }, []);
    react_1.useEffect(function () {
        if (props.show && props.level) {
            if (props.level.indexOf('B') != -1) {
                setBrandShow(true);
                props.brandId && setSelectedBrand({ brandId: props.brandId });
            }
            else if (props.level.indexOf('L') != -1) {
                setLineShow(true);
                props.brandId && setSelectedBrand({ brandId: props.brandId });
                props.lineId && setSelectedLine({ lineId: props.lineId });
            }
            else if (props.level.indexOf('P') != -1) {
                setProductShow(true);
                props.lineId && setSelectedLine({ lineId: props.lineId });
                props.productId && setSelectedProduct({ productId: props.productId });
            }
        }
    }, [props]);
    react_1.useEffect(function () {
        if (brandShow) {
            // 允许滚动
            smartScrollObj.brandPop.preventScroll();
        }
        else {
            smartScrollObj.brandPop.allowScroll();
        }
    }, [brandShow]);
    react_1.useEffect(function () {
        if (lineShow) {
            // 允许滚动
            smartScrollObj.linePop.preventScroll();
        }
        else {
            smartScrollObj.linePop.allowScroll();
        }
    }, [lineShow]);
    react_1.useEffect(function () {
        if (productShow) {
            // 允许滚动
            smartScrollObj.productPop.preventScroll();
        }
        else {
            smartScrollObj.productPop.allowScroll();
        }
    }, [productShow]);
    var closePop = react_1.useCallback(function (type) {
        // 关闭指定弹窗
        var bshow = brandShow, lshow = lineShow, pshow = productShow;
        // eslint-disable-next-line default-case
        switch (type) {
            case 'brand':
                bshow = false;
                setBrandShow(false);
                break;
            case 'line':
                lshow = false;
                setLineShow(false);
                break;
            case 'product':
                pshow = false;
                setProductShow(false);
                break;
        }
        if (!bshow && !lshow && !pshow) {
            props.closeFun && props.closeFun(props.fromId);
        }
    }, [brandShow, lineShow, productShow, props]);
    var selectBrandFun = react_1.useCallback(function (obj) {
        // 选择品牌
        if (!props.level) {
            return;
        }
        if (typeof props.clickBrandCallbackFun !== 'undefined') {
            props.clickBrandCallbackFun(obj);
        }
        if (props.level.indexOf('L') != -1 && obj.brandId) {
            setLineShow(true);
        }
        else {
            completeFun(obj);
        }
        setSelectedBrand(obj);
    }, [props, lineShow, selectedBrand]);
    var selectLineFun = react_1.useCallback(function (obj) {
        // 选择车系
        if (!props.level) {
            return;
        }
        var newObj = __assign(__assign({}, obj), { brandName: selectedBrand.brandName || '', brandLogo: selectedBrand.logoImg || '' });
        if (typeof props.clickLineCallbackFun !== 'undefined') {
            props.clickLineCallbackFun(newObj);
        }
        if (props.level.indexOf('P') != -1) {
            // 如果当前选择项没有lineId 并且设置的是显示选择全部
            if (!newObj.lineId && props.showLineSelectAll) {
                completeFun(newObj);
            }
            else {
                setProductShow(true);
            }
        }
        else {
            completeFun(newObj);
        }
        setSelectedLine(newObj);
    }, [props, productShow, selectedLine, selectedBrand]);
    var selectProductFun = react_1.useCallback(function (obj) {
        var newObj = __assign(__assign({}, obj), { brandName: selectedLine.brandName || '', lineName: selectedLine.lineName || '' });
        if (typeof props.clickProductCallbackFun !== 'undefined') {
            props.clickProductCallbackFun(newObj);
        }
        // 选择车型
        completeFun(newObj);
        setSelectedProduct(newObj);
    }, [selectedProduct, selectedLine]);
    var completeFun = react_1.useCallback(function (obj) {
        selectedClose &&
            props.level &&
            props.level.indexOf('B') != -1 &&
            setBrandShow(false);
        selectedClose &&
            props.level &&
            props.level.indexOf('L') != -1 &&
            setLineShow(false);
        selectedClose &&
            props.level &&
            props.level.indexOf('P') != -1 &&
            setProductShow(false);
        props.callbackFun && props.callbackFun(obj, props.fromId);
    }, [props, brandShow, lineShow, productShow]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (brandShow ? '' : 'hide') + " " + props.cn },
            react_1.default.createElement(BrandPop_1.BrandPop, { forcedCallback: true, selected: selectedBrand.brandId, show: brandShow, closeFun: function () { return closePop('brand'); }, saveKey: props.brandSaveKey, callbackFun: selectBrandFun, ajaxUrl: props.brandAjaxUrl, showSelectAll: props.showBrandSelectAll })),
        react_1.default.createElement(LinePop_1.LinePop, { closeFun: function () { return closePop('line'); }, callbackFun: selectLineFun, brandId: selectedBrand.brandId, lineId: selectedLine.lineId, show: lineShow, ajaxUrl: props.lineAjaxUrl, showSelectAll: props.showLineSelectAll, saveKey: props.lineSaveKey, showPrice: props.showLinePrice }),
        react_1.default.createElement(ProductPop_1.ProductPop, { closeFun: function () { return closePop('product'); }, callbackFun: selectProductFun, lineId: selectedLine.lineId, productId: selectedProduct.productId, show: productShow, ajaxUrl: props.productAjaxUrl, showSelectAll: props.showProdSelectAll, saveKey: props.productSaveKey })));
};
SelectBLP.defaultProps = {
    cn: '',
    fromId: '',
    brandAjaxUrl: undefined,
    lineAjaxUrl: undefined,
    productAjaxUrl: undefined,
    level: 'BLP',
    show: false,
    brandId: -1,
    lineId: -1,
    productId: -1,
    lineSaveKey: undefined,
    productSaveKey: undefined,
    showLinePrice: false,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
    // eslint-disable-next-line no-empty-function
    callbackFun: function (obj) { },
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(SelectBLP));
